module.exports = __webpack_public_path__ + "img/logo.a34b05da.png";